import { computedFrom, customElement } from 'aurelia-framework';
import { NavModel } from 'aurelia-router';
import { bindable } from 'aurelia-typed-observable-plugin';
import { NavGroupModel } from 'model/navigation';
import { PopoverOptions } from 'framework/html_behaviors/af-popover';

@customElement('bs-nav-group-item')
export class NavGroupItem {
  @bindable item: NavGroupModel;
  @bindable linkClicked: (args: childLinkClickedArgs) => true;
  @bindable groupLinkClicked: (args: groupLinkClickedArgs) => true;
  isPopover = false;
  popoverOptions: PopoverOptions = {
    placement: 'right-start',
    arrow: false,
    offset: [-5, 0],
    theme: 'light-border',
    onShown: () => this.onPopoverShown(),
    onHidden: () => this.onPopoverHidden()
  }

  childItemLinkClicked(nav: NavModel) {
    return this.linkClicked({ nav: nav, navGroup: this.item });
  }

  @computedFrom('item')
  get navGroupPopoverModel(): NavGroupPopoverModel {
    return {
      item: this.item,
      linkClicked: (nav: NavModel) => this.childItemLinkClicked(nav)
    }
  }

  onPopoverShown() {
    this.isPopover = true;
  }

  onPopoverHidden() {
    this.isPopover = false;
  }
}

export interface childLinkClickedArgs { nav: NavModel, navGroup: NavGroupModel }

export interface groupLinkClickedArgs { navGroup: NavGroupModel }

export interface NavGroupPopoverModel {
  item: NavGroupModel,
  linkClicked: (nav: NavModel) => true
}
